import { render, staticRenderFns } from "./CreateJournalButton.vue?vue&type=template&id=9080ea0e&scoped=true&"
import script from "./CreateJournalButton.vue?vue&type=script&lang=ts&"
export * from "./CreateJournalButton.vue?vue&type=script&lang=ts&"
import style0 from "./CreateJournalButton.vue?vue&type=style&index=0&id=9080ea0e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9080ea0e",
  null
  
)

export default component.exports